let DividerVariant = /*#__PURE__*/function (DividerVariant) {
  DividerVariant["GRAY"] = "gray";
  DividerVariant["SECONDARY"] = "secondary";
  DividerVariant["WHITE"] = "white";
  return DividerVariant;
}({});

export { DividerVariant };
//# sourceMappingURL=variant.js.map
